/* @flow */
import * as React from 'react';
import uuid from 'uuid';
import hoistStatics from 'hoist-non-react-statics';

const document = typeof window === 'undefined' ? {} : window.document;

type Title = { id: string, body: string };

let titles: Title[] = [];

export function unset(id: string) {
  titles = titles.filter(title => title.id !== id);
  refreshTitle();
}

export function set(body: string): string {
  const title = { id: uuid.v4(), body };
  titles.push(title);
  refreshTitle();
  return title.id;
}

function refreshTitle() {
  if (titles.length > 0) {
    document.title = titles[titles.length - 1].body;
  } else {
    document.title = 'Remind';
  }
}

export function withDocumentTitle<Props: {}>(
  body: string,
  ComposedComponent: React.ComponentType<Props>
) {
  class HOC extends React.Component<Props> {
    componentDidMount() {
      this.id = set(body);
    }

    componentWillUnmount() {
      unset(this.id);
    }

    id: string;

    render() {
      return <ComposedComponent {...this.props} />;
    }
  }

  return hoistStatics(HOC, ComposedComponent);
}
